import React from 'react'
import './Products3.css';

const Products3 = () => {
  return (
    <>
    <div className='body15'>
      <div className="container15">
        <div className="contentLeft15">
            <div className="row15">
                <div className="imgWrapper15">
                    <img src="/images/54.jpg" alt="" />
                </div>
                <div className="imgWrapper15">
                    <img src="/images/55.jpg" alt="" />
                </div>
                <div className="imgWrapper15">
                    <img src="/images/56.jpg" alt="" />
                </div>
                <div className="imgWrapper15">
                    <img src="/images/57.jpg" alt="" />
                </div>
            </div>
        </div>
        <div className="contentRight15">
            <div className="content15">
                {/* <h4>Welcome To</h4> */}
                <h2>PP Woven Sack</h2>
                <p>Our PP woven sack bags are engineered for durability and versatility. Renowned for their sturdiness and flexibility, they are the go-to choice for industries seeking reliable and cost-effective packaging solutions.</p>
                <a href="/View2">VIEW MORE</a>
            </div>
        </div>

      </div>
    </div>
    </>
  )
}

export default Products3
